module.exports = __webpack_public_path__ + "static/img/400.bbad9b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s32/pop/400.png
// module id = N8Yk
// module chunks = 2